<vwui-badge [class]="'badge' + (scoreThreshold ? (' badge--' + scoreThreshold) : '')">{{ scoreString }}</vwui-badge>
